import Icons, { IconsProps } from '../../Icons';

export type CalendarTodayProps = IconsProps;

export function CalendarToday(props: CalendarTodayProps) {
  return (
    <Icons {...props}>
      <path d="M5.625 21.1125C5.15833 21.1125 4.771 20.9585 4.463 20.6505C4.15433 20.3418 4 19.9542 4 19.4875V6.73751C4 6.27085 4.15433 5.88351 4.463 5.57551C4.771 5.26685 5.15833 5.11251 5.625 5.11251H7.375V2.88751H8.45V5.11251H15.625V2.88751H16.625V5.11251H18.375C18.8417 5.11251 19.2293 5.26685 19.538 5.57551C19.846 5.88351 20 6.27085 20 6.73751V19.4875C20 19.9542 19.846 20.3418 19.538 20.6505C19.2293 20.9585 18.8417 21.1125 18.375 21.1125H5.625ZM5.625 20.1125H18.375C18.5417 20.1125 18.6873 20.0498 18.812 19.9245C18.9373 19.7998 19 19.6542 19 19.4875V10.7375H5V19.4875C5 19.6542 5.06267 19.7998 5.188 19.9245C5.31267 20.0498 5.45833 20.1125 5.625 20.1125ZM5 9.73751H19V6.73751C19 6.57085 18.9373 6.42518 18.812 6.30051C18.6873 6.17518 18.5417 6.11251 18.375 6.11251H5.625C5.45833 6.11251 5.31267 6.17518 5.188 6.30051C5.06267 6.42518 5 6.57085 5 6.73751V9.73751Z" />
    </Icons>
  );
}

// https://www.zhangxinxu.com/sp/svgo/
// https://jakearchibald.github.io/svgomg/
